export default function ({ store, redirect }) {
  if (!store.getters['user/hasJointsWithLogins']) {
    return redirect('/dashboard');
  }
}
